module.exports = __webpack_public_path__ + "static/img/GuardGroup.461377e1.png";